import React, { useState, useEffect } from "react";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Field } from "./Login";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const nav = useNavigate();
  useEffect(() => { setToken(sp.get("token") || ""); }, [sp]);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please login.");
      nav("/login");
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail)); }
  };
  return (
    <main className="max-w-md mx-auto p-8">
      <h1 className="font-display text-3xl font-bold">Reset Password</h1>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <Field label="Reset Token" value={token} onChange={setToken} testid="reset-token"/>
        <Field label="New Password" type="password" value={pw} onChange={setPw} testid="reset-pw"/>
        <button data-testid="reset-submit" className="btn-primary-sf w-full py-3 rounded-full font-semibold">Reset Password</button>
      </form>
    </main>
  );
}
